import app from './app/selectors';
import modal from './modal/selectors';
import user from './user/selectors';
import documents from './documents/selectors';
import normalizer from './normalizer/selectors';
import configurator from './configurator/selectors';
import userReportSettings from './userReportSettings/selectors';
import chatbot from './chatbot/selectors';

export default {
  app,
  user,
  documents,
  normalizer,
  modal,
  configurator,
  userReportSettings,
  chatbot,
};
